import React, { useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { url } from "../../../services/constant";
import { Span, StyledText } from "../../../components/common/basic";
import {
  CheckCirclIcon,
  TimerBig,
  CheckCircleBig,
} from "../../../components/svgs";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import { Body, Children, MainHolder } from "../../../components/common/basic";
import { useTheme, useLoyalty } from "../../../hooks";
import { BackButton, Box } from "../../../components/common";
import useReferrals from "./hooks/useReferrals";

const RedemptionStatus = () => {
  const { themeContext, theme } = useTheme();
  const history = useHistory();
  const { id } = history.location.state;
  const { referralsRewardItems, redemptions } = useReferrals();
  const foundRedemption = redemptions
    .find((redemption) => redemption._id === id);
  const {
    region,
    branch,
    reward,
    status,
    pointsRedeem,
    quantity,
  } = foundRedemption || {};


  const orderStatus = status?.toLowerCase();
  const fullPickupLocation = `${region}, ${branch}`;
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const styles = generateStyles();

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "CaptureAndShareOrderStatus",
        firebase_screen_class: "CaptureAndShareOrderStatus",
      })
    );
  }, []);

  return (
    <MainHolder style={{ background: "white" }}>
      <Children>
        <BackButton
          onClick={() => {
            history.push('/referral');
          }}
        />

        <Body>
          <RedeemedItem backgroundColor={"#f2f2f2"}>
            <RedeemedImage src={`${reward?.imageUrl}`} />
            <CaptureContent>
              <StyledText size={18} margin={0}>
                {reward?.name}
              </StyledText>
              <div
                style={{
                  backgroundColor: "#e91e63",
                  padding: "3px 5px",
                }}
              >
                <StyledText color='white' size={11} style={{ margin: 0 }}>
                  {`${pointsRedeem} points`}
                </StyledText>
              </div>
            </CaptureContent>
          </RedeemedItem>
          <StyledText style={{ margin: "18px 10px" }}>Quantity - {quantity}</StyledText>

          <StyledText style={{
            margin: "10px 10px",
            display: reward?.category === "data" ? "none" : "block"
          }}>
            <span
              style={{
                fontFamily: "MTNRegular",
                color: "#7F7F7F",
              }}
            >
              Pickup point
            </span>{" "}
            {fullPickupLocation}
          </StyledText>
          <Box
            style={{
              backgroundColor: "#f2f2f2",
              height: 1,
              margin: "30px 10px",
            }}
          />
          <StyledText
            size={18}
            style={{ margin: "18px 10px" }}
          >{`Order Status`}</StyledText>
          {
            reward?.category !== "data" &&
            <OrderEnrouteContainer>
              <OrderEnrouteIconContainer>
                {orderStatus === "pending" ? (
                  <Circle />
                ) : (
                  <CheckCirclIcon fill={"#0FAF4B"} />
                )}
                <Line color='#BDBDBD' />
                {orderStatus === "ready" ? (
                  <CheckCirclIcon fill={"#0FAF4B"} />
                ) : (
                  <Circle />
                )}
              </OrderEnrouteIconContainer>
              <OrderEnrouteContent>
                <StyledText
                  size={14}
                  style={{
                    ...styles.textStyle,
                    alignSelf: "flex-start",
                    marginLeft: 10,
                    fontFamily: "MTNRegular",
                  }}
                >
                  {`Voucher Enroute to`}
                  <Span
                    size={14}
                    color={"#e91e63"}
                  >{` ${fullPickupLocation}`}</Span>
                </StyledText>
                <StyledText
                  size={14}
                  style={{
                    ...styles.textStyle,
                    alignSelf: "flex-start",
                    marginLeft: 10,
                    fontFamily: "MTNRegular",
                  }}
                >
                  {`Voucher Ready for Pickup`}
                </StyledText>
              </OrderEnrouteContent>
            </OrderEnrouteContainer>
          }
          <Content>
            <OrderCardContainer>
              <OrderStatusCard
                background={
                  orderStatus === "pending" || orderStatus === "enroute"
                    ? "#FFCD00"
                    : "#0FAF4B"
                }
              >
                <TimerContainer>
                  {orderStatus === "ready" ? (
                    <CheckCircleBig />
                  ) : (
                    <TimerBig fill={"black"} />
                  )}
                </TimerContainer>
                <StatusContent>
                  <StyledText
                    color={orderStatus === "ready" ? "white" : "black"}
                    style={styles.textStyle}
                    size={14}
                  >
                    {orderStatus === "ready" ? `Order Ready` : `Order Pending`}
                  </StyledText>
                  <StyledText
                    color={orderStatus === "ready" ? "white" : "black"}
                    style={{ ...styles.textStyle, fontFamily: "MTNRegular" }}
                    size={10}
                  >
                    {orderStatus === "ready"
                      ? `Visit selected MTN Office to pickup reward`
                      : `You will be notified when your order is ready`}
                  </StyledText>
                </StatusContent>
              </OrderStatusCard>
            </OrderCardContainer>
          </Content>
        </Body>
      </Children>
    </MainHolder >
  );
};

const generateStyles = () => {
  return {
    textStyle: {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
  };
};

const RedeemedItem = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${(prop) => prop.backgroundColor};
  padding: 10px;
  align-items: flex-start;
  margin: 10px;
  border-radius: 1px;
`;

const RedeemedImage = styled.img`
  width: 75px;
  height: 75px;
`;

const CaptureContent = styled.div`
  padding: 0px 3px 3px 3px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  jusitfy-content: flex-start;
  margin: 10px 0px 0px 10px;
`;

const Content = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`;

const OrderCardContainer = styled.div`
  margin-top: 30px;
  display: flex;
`;

const OrderStatusCard = styled.div`
  flex: 1;
  height: 65px;
  background-color: ${({ background }) => background};
  border-radius: 15px;
  display: flex;
  padding: 5px;
  align-items: center;
`;

const TimerContainer = styled.div`
  display: flex;
  width: 20%;
  justify-content: center;
  align-items: center;
`;

const StatusContent = styled.div`
  padding: 8px;
`;

const OrderEnrouteContainer = styled.div`
  display: flex;
`;

const OrderEnrouteIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 5px;
  align-items: center;
  margin-left: 8px;
`;

const OrderEnrouteContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Circle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: #bdbdbd;
`;
const Line = styled.div`
  width: 2px;
  background-color: ${({ color }) => color};
  height: 30px;
`;

export default RedemptionStatus;
